import $ from "jquery";
import Tracker from "./../common/tracker";

const Api = (($) => {
  const ProfileEndpoint = "/_system/api/crm/rental-analysis/profiles/";
  const RentalAnalysisEndpoint = "/_system/api/crm/rental-analysis/requests/";
  const TrackingNumberEndpoint = "/_system/api/crm/tracking-number-profiles/";

  class Api {
    constructor() {}

    getProfile(id) {
      return $.ajax({
        url: ProfileEndpoint + id,
        method: "GET",
        dataType: "json",
      });
    }

    getTrackingNumberProfile(id) {
      return $.ajax({
        url: TrackingNumberEndpoint + id,
        method: "GET",
        dataType: "json",
      });
    }

    getRentalAnalysisRequest(profileID, leadID) {
      let headers = {};

      headers["x-ion-rental-analysis-profile"] = profileID;

      return $.ajax({
        url: `${RentalAnalysisEndpoint}${leadID}`,
        headers: headers,
        method: "GET",
      });
    }

    submitRentalAnalysis(id, data) {
		let headers = {},
			trackingCode = Tracker.getTrackingCode(),
			referrer = Tracker.getReferrer(),
			utmData = Tracker.getUTMCodes(),
			googleAdsClickID = Tracker.getGoogleAdsClickID();

     	 headers["X-ion-source-url"] = document.location.href;

		if (trackingCode) {
			headers["X-ion-tracking-code"] = trackingCode;
		}

		if (referrer) {
			headers["X-ion-referrer"] = referrer;
		}

	  	if (Object.keys(utmData).length > 0) {
			if (utmData.utmID) {
				headers["X-ion-utm-id"] = utmData.utmID;
			}
			if (utmData.utmSource) {
				headers["X-ion-utm-source"] = utmData.utmSource;
			}
			if (utmData.utmMedium) {
				headers["X-ion-utm-medium"] = utmData.utmMedium;
			}
			if (utmData.utmCampaign) {
				headers["X-ion-utm-campaign"] = utmData.utmCampaign;
			}
			if (utmData.utmTerm) {
				headers["X-ion-utm-term"] = utmData.utmTerm;
			}
			if (utmData.utmContent) {
				headers["X-ion-utm-content"] = utmData.utmContent;
			}
		}

		if (googleAdsClickID) {
			headers["X-ion-gclid"] = googleAdsClickID;
		}

      	headers["x-ion-rental-analysis-profile"] = id;

		return $.ajax({
			url: RentalAnalysisEndpoint + "one-step",
			headers: headers,
			method: "POST",
			dataType: "json",
			data: data,
		});
    }

    submitRentalAnalysisStepOne(profileID, data) {
		let headers = {},
			trackingCode = Tracker.getTrackingCode(),
			referrer = Tracker.getReferrer(),
			utmData = Tracker.getUTMCodes(),
			googleAdsClickID = Tracker.getGoogleAdsClickID();

     	headers["X-ion-source-url"] = document.location.href;

		if (trackingCode) {
			headers["X-ion-tracking-code"] = trackingCode;
		}

		if (referrer) {
			headers["X-ion-referrer"] = referrer;
		}

		if (Object.keys(utmData).length > 0) {
			if (utmData.utmID) {
				headers["X-ion-utm-id"] = utmData.utmID;
			}
			if (utmData.utmSource) {
				headers["X-ion-utm-source"] = utmData.utmSource;
			}
			if (utmData.utmMedium) {
				headers["X-ion-utm-medium"] = utmData.utmMedium;
			}
			if (utmData.utmCampaign) {
				headers["X-ion-utm-campaign"] = utmData.utmCampaign;
			}
			if (utmData.utmTerm) {
				headers["X-ion-utm-term"] = utmData.utmTerm;
			}
			if (utmData.utmContent) {
				headers["X-ion-utm-content"] = utmData.utmContent;
			}
		}

		if (googleAdsClickID) {
			headers["X-ion-gclid"] = googleAdsClickID;
		}

      	headers["x-ion-rental-analysis-profile"] = profileID;

		return $.ajax({
			url: RentalAnalysisEndpoint + "step/one",
			headers: headers,
			method: "POST",
			dataType: "json",
			data: data,
		});
    }

    submitRentalAnalysisStepTwo(profileID, requestID, data) {
		let headers = {},
			trackingCode = Tracker.getTrackingCode(),
			referrer = Tracker.getReferrer(),
			utmData = Tracker.getUTMCodes(),
			googleAdsClickID = Tracker.getGoogleAdsClickID();

     	 headers["X-ion-source-url"] = document.location.href;

		if (trackingCode) {
			headers["X-ion-tracking-code"] = trackingCode;
		}

		if (referrer) {
			headers["X-ion-referrer"] = referrer;
		}

		if (Object.keys(utmData).length > 0) {
			if (utmData.utmID) {
				headers["X-ion-utm-id"] = utmData.utmID;
			}
			if (utmData.utmSource) {
				headers["X-ion-utm-source"] = utmData.utmSource;
			}
			if (utmData.utmMedium) {
				headers["X-ion-utm-medium"] = utmData.utmMedium;
			}
			if (utmData.utmCampaign) {
				headers["X-ion-utm-campaign"] = utmData.utmCampaign;
			}
			if (utmData.utmTerm) {
				headers["X-ion-utm-term"] = utmData.utmTerm;
			}
			if (utmData.utmContent) {
				headers["X-ion-utm-content"] = utmData.utmContent;
			}
		}

		if (googleAdsClickID) {
			headers["X-ion-gclid"] = googleAdsClickID;
		}

		headers["x-ion-rental-analysis-profile"] = profileID;
		headers["x-ion-rental-analysis-request"] = requestID;

		return $.ajax({
			url: RentalAnalysisEndpoint + "step/two",
			headers: headers,
			method: "POST",
			dataType: "json",
			data: data,
		});
	}
  }

  return new Api();
})($);

export default Api;
